import { useEffect, useState } from 'react'

import { useDispatch } from 'react-redux'

import { SubmissionChannels } from '@enums'
import { applyAudienceInsightFilters } from '@store/audienceInsights'
import { IOption } from '@store/rootResource/types'
import { AnalyticsBrandConnectPostPurchaseBreakdown } from './BrandConnectPostPurchaseBreakdown'
import { AnalyticsBreakdown } from './Breakdown'
import { defaultSourceOption, SOURCE_OPTIONS } from './Filter'
import { usePostPurchaseBreakdown } from './usePostPurchaseBreakdown'

type Props = {
  submissionId: number
}

export const AnalyticsPostPurchaseBreakdown: React.FC<Props> = ({ submissionId }) => {
  const dispatch = useDispatch()
  const {
    isFetching,
    analytics,
    currency,
    socialSubmissionType,
    isProxy,
    channel,
    mediaType,
    isYouTubeBrandConnect,
    brandConnectMetrics,
  } = usePostPurchaseBreakdown(submissionId)

  const [source, setSource] = useState<IOption>(defaultSourceOption)

  // Apply filter to audience insights when traffic_source changes
  useEffect(() => {
    if (isYouTubeBrandConnect) {
      dispatch(
        applyAudienceInsightFilters({
          traffic_source: source.value as string,
        }),
      )
    }
  }, [source, isYouTubeBrandConnect, dispatch])

  const isBrandConnectV2Metrics =
    channel === SubmissionChannels.YouTube &&
    isYouTubeBrandConnect

  if (isBrandConnectV2Metrics) {
    return (
      <AnalyticsBrandConnectPostPurchaseBreakdown
        analytics={brandConnectMetrics}
        isLoaded={!isFetching}
        currency={currency!}
        socialSubmissionType={socialSubmissionType}
        channel={channel as SubmissionChannels}
        mediaType={mediaType}
        isProxy={isProxy}
        filters={{
          traffic_source: {
            filterLabel: 'Source',
            onChange: setSource,
            options: SOURCE_OPTIONS,
            selected: source,
          },
        }}
      />
    )
  }

  return (
    <AnalyticsBreakdown
      isLoaded={!isFetching}
      perspective="post-purchase"
      analytics={analytics}
      currency={currency!}
      socialSubmissionType={socialSubmissionType}
      isProxy={isProxy}
      channel={channel as SubmissionChannels}
      mediaType={mediaType}
    />
  )
}
